import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Card } from "antd";
import { useTranslation } from "react-i18next";
import { useFetchTeamMemberQuery } from "./team.service";
import moment from "moment";
import { trainingLevel } from "../../constant";

export default function TeamView() {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { id } = useParams();

  const handleBack = () => {
    navigate("/team");
  };

  const { data = {} } = useFetchTeamMemberQuery(id);

  return (
    <Card
      className="team-view-page"
      bordered={false}
      title={t("TEAM MEMBER")}
      extra={<Button onClick={handleBack}>{t("BACK")}</Button>}
    >
      <div className="team-view-page-container">
        <div className="team-view-page-container-field">
          <div className="team-view-page-container-field-label">
            {t("NAME")}
          </div>
          <div className="team-view-page-container-field-value">
            {data.name}
          </div>
        </div>
        <div className="team-view-page-container-field">
          <div className="team-view-page-container-field-label">
            {t("EMAIL")}
          </div>
          <div className="team-view-page-container-field-value">
            {data.email}
          </div>
        </div>
        <div className="team-view-page-container-field">
          <div className="team-view-page-container-field-label">
            {t("DATE OF BIRTH")}
          </div>
          <div className="team-view-page-container-field-value">
            {moment(data.dateOfBirth).format("YYYY-MM-DD")}
          </div>
        </div>
        <div className="team-view-page-container-field">
          <div className="team-view-page-container-field-label">
            {t("MOBILE NUMBER")}
          </div>
          <div className="team-view-page-container-field-value">
            {data.mobileNumber}
          </div>
        </div>
        <div className="team-view-page-container-field">
          <div className="team-view-page-container-field-label">
            {t("TRAINING LEVEL")}
          </div>
          <div className="team-view-page-container-field-value">
            {trainingLevel[data.trainingLevel]}
          </div>
        </div>
        <div className="team-view-page-container-field">
          <div className="team-view-page-container-field-label">
            {t("HYGIENE TRAINING")}
          </div>
          <div className="team-view-page-container-field-value">
            {data.hygieneTraining ? "YES" : "NO"}
          </div>
        </div>
        <div className="team-view-page-container-field">
          <div className="team-view-page-container-field-label">
            {t("ALLERGEN TRAINING")}
          </div>
          <div className="team-view-page-container-field-value">
            {data.allergenTraining ? "YES" : "NO"}
          </div>
        </div>
      </div>
    </Card>
  );
}
